import { useEffect } from 'react';

import { HiveCalendar } from '../hive-calendar/hive-calendar';
import styles from './header.module.scss';
import { IconWrapper } from '@flexo/general';
import React from 'react';
import { HeaderEntityDropdown } from '@flexo/atoms';
import { useHeaderEntities } from './hooks/useHeaderEntities';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MODAL, RootState } from '@flexo/reducers';
// import { backdropClasses } from '@mui/material';

function Header(props) {
  const {
    Header__Title,
    Header__Actions,
    Header__Actions__Button,
    Header__Heading,
    Header__Calendar,
  } = styles;

  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  const modalState = useSelector((state: RootState) => state.modalContext);
  const dispatch = useDispatch();
  const metadata = useSelector((state: any) => state.metadata);

  const onClickProfile = () => {
    dispatch(
      MODAL.OpenModal({
        content: 'PROFILE',
        props: props,
      })
    );
  };

  // const visibleModule = pathSegment;

  useEffect(() => {
    const fetchInsets = async () => {
      try {
        await SafeArea.getSafeAreaInsets();
        // setInsets(insets);
      } catch (error) {
        console.error('Error fetching safe area insets:', error);
      }
    };

    fetchInsets();
  }, []);

  const headerEntities = useHeaderEntities();

  return (
    <div
      className={` ion-safe-area ${styles.Header} ${
        pathSegment !== 'household' ? styles.Header__Community : ''
      } `}
    >
      <div className={Header__Heading}>
        <div className={`${Header__Title} heading1`}>
          <HeaderEntityDropdown
            items={headerEntities.items}
            selected={headerEntities.selected}
            getLabel={headerEntities.getLabel}
            getId={headerEntities.getId}
            getDescription={headerEntities.getDescription}
            onSelect={headerEntities.onSelect}
            disabled={headerEntities.disabled}
            singleItem={headerEntities.singleItem}
            noOptionsText={headerEntities.noOptionsText}
            fullWidth={false}
          />
        </div>

        <div className={Header__Actions}>
          {/* <button
            className={Header__Actions__Button}
            onClick={onClickNotifications}
          >
            <IconWrapper iconName="notifications" />
          </button> */}
          <button
            className={Header__Actions__Button}
            onClick={() => onClickProfile()}
            disabled={modalState?.open === true}
          >
            <IconWrapper
              iconName="user_solid"
              style={{ marginRight: '-8px' }}
            />
          </button>
        </div>
      </div>
      <div className={Header__Calendar}>
        <HiveCalendar calendarColor={props.calendarColor} />
      </div>
    </div>
  );
}

export default React.memo(Header);
